export function ResetPassword() {
  return (
    <div>
      <p>Reset Password</p>
    </div>
  )
}
